<template>
  <div class="page-wrap">
    <!-- 头部 -->
    <header class="page-header">
      <div class="page-header-left">
        <div class="page-eyebrow">Metta · Vehicle Library</div>
        <h1 class="page-title">载具库</h1>
      </div>
      <div class="page-count">{{ visibleCount }} 款载具</div>
    </header>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-row filter-row-series">
        <button
          v-for="tag in seriesTags"
          :key="tag.value"
          class="series-tag"
          :class="{ active: activeFilter === tag.value }"
          @click="setFilter(tag.value)"
        >
          {{ tag.label }}
        </button>
      </div>
    </div>

    <!-- 载具网格 -->
    <div class="grid-wrapper">
      <div class="vehicle-grid">
        <div
          v-for="(vehicle, index) in filteredVehicles"
          :key="vehicle.id + index"
          class="vehicle-card fade-in"
          :style="{ animationDelay: index * 15 + 'ms' }"
          @click="handleCardClick(vehicle)"
        >
          <div class="card-img">
            <img 
              :src="`${imgUrlPrefix}${vehicle.id}.jpg`" 
              :alt="vehicle.name"
              @error="$event.target.style.display='none'"
            />

            <div class="card-tags">
              <span v-if="vehicle.status === 'concept'" class="tag tag-concept">Concept</span>
              <span class="tag tag-series">{{ vehicle.series[0] }}</span>
            </div>
          </div>

          <div class="card-info">
            <div class="card-eyebrow">{{ getEyebrow(vehicle.series) }}</div>
            <div class="card-divider"></div>

            <div class="card-name-row">
              <span>{{ vehicle.name }}</span>
              <span v-if="vehicle.doors" class="tag-doors">{{ vehicle.doors }}</span>
              <span v-if="vehicle.tag" class="tag-fuel">{{ vehicle.tag }}</span>
            </div>
            
            <div class="card-status">
              <div class="status-track">
                <div 
                  class="status-dot" 
                  :class="{ filled: 0 <= getStatusStage(vehicle.status), empty: 0 > getStatusStage(vehicle.status) }"
                ></div>

                <div 
                  class="status-line" 
                  :class="{ filled: 0 < getStatusStage(vehicle.status), empty: 0 >= getStatusStage(vehicle.status) }"
                ></div>
                
                <div 
                  class="status-dot" 
                  :class="{ filled: 1 <= getStatusStage(vehicle.status), empty: 1 > getStatusStage(vehicle.status) }"
                ></div>

                <div 
                  class="status-line" 
                  :class="{ filled: 1 < getStatusStage(vehicle.status), empty: 1 >= getStatusStage(vehicle.status) }"
                ></div>
                
                <div 
                  class="status-dot" 
                  :class="{ filled: 2 <= getStatusStage(vehicle.status), empty: 2 > getStatusStage(vehicle.status) }"
                ></div>
              </div>
              
              <div class="status-labels">
                <span class="status-label">Concept</span>
                <span class="status-label status-label-center">Deposit</span>
                <span class="status-label" :class="{ 'price-label': vehicle.price }">
                  {{ vehicle.price || 'On Sale' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 CTA -->
    <footer class="footer-cta">
      <div class="footer-eye">Community</div>
      <h2 class="footer-title">加入麦塔社区</h2>
      <p class="footer-body">分享你的路线、改装与旅途，和更多同路人相遇。</p>
      <button class="btn-white" @click="$router.push({ name: 'MettaCommunity' })">加入社区 →</button>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrlPrefix: '/assets/images/vehicles/',

      seriesTags: [
        { label: '全部', value: 'all' },
        { label: 'Origin', value: 'Origin' },
        { label: 'Classic', value: 'Classic' },
        { label: 'Performance', value: 'Performance' },
      ],

      activeFilter: 'all',

      vehicles: [
        { id:'metta', name:'METTA', series:['Origin'], doors:null, status:'on-sale', price:'¥ 189,900' },
        { id:'hunshadake_ badanjilin', name:'METTA 巴丹吉林', series:['Origin'], doors:null, status:'on-sale', price:'¥ 219,900' },
        { id:'hunshadake_ badanjilin', name:'METTA 浑善达克', series:['Origin'], doors:null, status:'concept', price:null, tag:'柴油版' },

        { id:'n30-rocky', name:'N30° 洛基', series:['Classic'], doors:'五门', status:'concept', price:null },
        { id:'n30-petra', name:'N30° 佩特拉', series:['Classic'], doors:'三门', status:'concept', price:null },
        { id:'n30-global-5door', name:'N30° 环球穿越', series:['Classic'], doors:'五门', status:'deposit', price:null },
        { id:'n30-global-3door', name:'N30° 环球穿越', series:['Classic'], doors:'三门', status:'concept', price:null },

        { id:'performance-ultra', name:'Ultra', series:['Performance'], doors:null, status:'deposit', price:null },
        { id:'performance-dakar', name:'达喀尔', series:['Performance'], doors:null, status:'deposit', price:null },
        { id:'performance-badain100', name:'巴丹100', series:['Performance'], doors:null, status:'deposit', price:null },
      ],
    };
  },

  computed: {
    filteredVehicles() {
      if (this.activeFilter === 'all') {
        return this.vehicles;
      }

      return this.vehicles.filter(v => v.series.includes(this.activeFilter));
    },

    visibleCount() {
      return this.filteredVehicles.length;
    }
  },

  methods: {
    setFilter(filterValue) {
      this.activeFilter = filterValue;
    },

    getEyebrow(seriesArray) {
      return seriesArray.join(' · ');
    },

    getStatusStage(status) {
      if (status === 'on-sale') return 2;
      if (status === 'deposit') return 1;
      return 0;
    },

    handleCardClick(vehicle) {
      console.log('Clicked vehicle:', vehicle);
    }
  }
};
</script>

<style lang="less" scoped>
.page-wrap {
  background: @bg;
  min-height: 100vh;

  .page-header {
    padding: 48px 40px 32px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    border-bottom: 1px solid @bdr;
    
    .page-eyebrow {
      font-size: 8px;
      letter-spacing: 4px;
      text-transform: uppercase;
      color: @mute;
      font-weight: 300;
      margin-bottom: 10px;
    }

    .page-title {
      font-size: 48px;
      font-weight: 100;
      letter-spacing: -1.5px;
      line-height: 1;
      color: @ink;
    }

    .page-count {
      font-size: 9px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: @mute;
      font-weight: 300;
    }
  }

  .filter-bar {
    position: sticky;
    top: 52px;
    z-index: 88;
    background: @glass;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid @bdr;
    padding: 0 40px;

    .filter-row {
      display: flex;
      align-items: center;
      height: 44px;
    }

    .filter-row-series {
      gap: 4px;
    }

    .series-tag {
      font-size: 9px;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: @mid;
      padding: 5px 12px;
      border: 0.5px solid rgba(8, 8, 8, 0.15);
      background: transparent;
      font-family: inherit;
      font-weight: 300;
      cursor: pointer;
      transition: all .15s;
      white-space: nowrap;

      &:hover {
        color: @ink;
        border-color: rgba(8, 8, 8, 0.4);
      }

      &.active {
        color: @bg;
        background: @ink;
        border-color: @ink;
      }
    }
  }

  .grid-wrapper {
    padding: 32px 40px 80px;
  }

  .vehicle-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    background: transparent;
  }

  .vehicle-card {
    background: transparent;
    border: none;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    transition: transform .2s ease;

    &:hover {
      transform: translateY(-3px);
      z-index: 2;
    }

    .card-img {
      height: 240px;
      background: #f0f0ee;
      position: relative;
      overflow: hidden;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .card-tags {
      position: absolute;
      top: 10px;
      left: 10px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      z-index: 1;
    }
    
    .tag {
      display: inline-block;
      font-size: 8px;
      letter-spacing: 2px;
      text-transform: uppercase;
      padding: 3px 7px;
      border: 0.5px solid;
      font-family: inherit;
      font-weight: 300;
      white-space: nowrap;

      &.tag-concept {
        background: @ink;
        color: @bg;
        border-color: @ink;
      }

      &.tag-series {
        background: rgba(247, 247, 245, 0.85);
        color: @mid;
        border-color: rgba(8, 8, 8, 0.2);
      }
    }

    .card-info {
      background: rgba(247, 247, 245, 0.72);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-top: none;
      padding: 20px 24px 24px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0;
      flex: 1;
    }

    .card-eyebrow {
      font-size: 8px;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      color: @mute;
      font-weight: 300;
      text-align: left;
      margin-bottom: 8px;
    }

    .card-divider {
      width: 20px;
      height: 0.5px;
      background: @bdr;
      margin-bottom: 8px;
    }

    .card-name-row {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 15px;
      font-weight: 300;
      letter-spacing: 0.5px;
      text-align: left;
      margin-bottom: 14px;
      flex-wrap: wrap;
    }

    .tag-doors {
      font-size: 7px;
      letter-spacing: 1.5px;
      text-transform: uppercase;
      padding: 2px 6px;
      border: 0.5px solid rgba(8, 8, 8, 0.2);
      color: @mid;
      background: transparent;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .tag-fuel {
      font-size: 7px;
      letter-spacing: 2px;
      text-transform: uppercase;
      padding: 2px 8px;
      border: 0.5px solid rgba(8, 8, 8, 0.2);
      color: #a6a6a4;
      background: transparent;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .card-status {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      width: 100%;
      margin-top: 14px;
    }

    .status-track {
      display: flex;
      align-items: center;
      width: 160px;
    }

    .status-dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      flex-shrink: 0;

      &.filled {
        background: @ink;
      }

      &.empty {
        background: @bdr;
      }
    }

    .status-line {
      flex: 1;
      height: 0.5px;

      &.filled {
        background: @ink;
      }

      &.empty {
        background: @bdr;
      }
    }

    .status-labels {
      display: flex;
      justify-content: space-between;
      width: 160px;
    }
    
    .status-label {
      font-size: 8px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: @mute;
      font-weight: 300;
      text-align: left;
      flex: 1;

      &:last-child {
        text-align: right;
      }

      &.price-label {
        font-size: 11px;
        color: @ink;
        letter-spacing: 0;
        text-transform: none;
        text-align: right;
      }

      &.status-label-center {
        text-align: center;
      }
    }
  }

  .footer-cta {
    display: none;
  }

  .fade-in {
    animation: cardIn .25s ease both;
  }
  
  @keyframes cardIn {
    from {
      opacity: 0;
      transform: translateY(6px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media screen and (max-width: 768px) {
  .page-wrap {
    overflow-x: hidden;

    .page-header {
      padding: 80px 24px 32px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .page-eyebrow {
        font-size: 8px;
        letter-spacing: 4px;
        margin-bottom: 10px;
        font-family: 'Roboto Mono', monospace;
      }

      .page-title {
        font-size: 40px;
        letter-spacing: -1.5px;
      }

      .page-count {
        font-size: 8px;
        letter-spacing: 2px;
        padding-bottom: 4px;
      }
    }

    .filter-bar {
      top: 52px;
      padding: 0;
      background: @glass;

      .filter-row-series {
        height: 44px;
        overflow-x: auto;
        padding: 0 24px;
        gap: 4px;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .series-tag {
        flex-shrink: 0;
        font-size: 9px;
        letter-spacing: 1.5px;
        padding: 5px 12px;
      }
    }

    .grid-wrapper {
      padding: 24px 24px 40px;
    }

    .vehicle-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .vehicle-card {
      margin-bottom: 0;

      &:hover {
        transform: none;
      }

      &:active {
        transform: scale(0.99);
      }

      .card-img {
        height: 220px;

        img {
          object-fit: contain;
        }
      }

      .card-tags {
        top: 10px;
        left: 10px;
      }

      .tag {
        font-size: 7px;
        letter-spacing: 2px;
        padding: 3px 6px;
      }

      .card-info {
        padding: 16px 18px 20px;
      }

      .card-eyebrow {
        font-size: 7px;
        letter-spacing: 2.5px;
        margin-bottom: 6px;
      }

      .card-divider {
        width: 16px;
        margin-bottom: 6px;
      }

      .card-name-row {
        font-size: 14px;
        margin-bottom: 12px;
      }

      .tag-doors,
      .tag-fuel {
        font-size: 7px;
        padding: 2px 6px;
      }

      .card-status {
        margin-top: 0;
        gap: 5px;
      }

      .status-track {
        width: 100%;
        max-width: 200px;
      }

      .status-labels {
        width: 100%;
        max-width: 200px;
      }

      .status-label {
        font-size: 7px;

        &.price-label {
          font-size: 10px;
        }
      }
    }

    .footer-cta {
      display: block;
      background: #080808;
      padding: 56px 24px;
      text-align: center;

      .footer-eye {
        font-size: 8px;
        letter-spacing: 4px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.25);
        margin-bottom: 16px;
      }

      .footer-title {
        font-size: 28px;
        font-weight: 100;
        color: #fff;
        letter-spacing: -1px;
        line-height: 1.1;
        margin-bottom: 14px;
      }

      .footer-body {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
        line-height: 2;
        margin: 0 auto 28px;
        max-width: 280px;
      }

      .btn-white {
        border: none;
        background: #fff;
        color: #080808;
        padding: 12px 32px;
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        font-family: inherit;
        font-weight: 300;
        cursor: pointer;
      }
    }
  }
}
</style>